var _path, _rect, _rect2, _path2, _circle, _circle2, _circle3, _path3, _path4, _mask, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSayhiCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 111,
    viewBox: "0 0 143 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112 27C112 24.7909 110.209 23 108 23H32C29.7909 23 28 24.7909 28 27V74.0357C28 76.2449 29.7909 78.0357 32 78.0357H41.4424C42.5757 78.0357 43.6559 78.5165 44.4144 79.3586L51.028 86.7006C52.6168 88.4644 55.3832 88.4644 56.972 86.7006L63.5856 79.3586C64.3441 78.5165 65.4243 78.0357 66.5576 78.0357H108C110.209 78.0357 112 76.2449 112 74.0357V27Z",
    fill: "url(#paint0_linear_18278_92738)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 38,
    width: 53,
    height: 7,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 56,
    width: 30,
    height: 7,
    rx: 3.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143 57C143 55.3431 141.657 54 140 54H83C81.3431 54 80 55.3431 80 57V94.5357C80 96.1926 81.3431 97.5357 83 97.5357H114.034C114.912 97.5357 115.745 97.92 116.315 98.5874L121.219 104.329C122.416 105.731 124.584 105.731 125.781 104.329L130.685 98.5874C131.255 97.92 132.088 97.5357 132.966 97.5357H140C141.657 97.5357 143 96.1926 143 94.5357V57Z",
    fill: "url(#paint1_linear_18278_92738)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 76,
    r: 4,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 111,
    cy: 76,
    r: 4,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 127,
    cy: 76,
    r: 4,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136 3L117 10.0691L127 12.0042L129.503 22L136 3Z",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.008 12.0042L129.836 9.17578",
    stroke: "#8B93A7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-10-inside-1_18278_92738",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 110.796C5.7404 110.318 -9.30118e-07 104.279 -6.07506e-07 96.8981C-2.84893e-07 89.5176 5.7404 83.4778 13 83L13 110.796Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 110.796L15 110.796L15 112.932L12.8686 112.792L13 110.796ZM13 83L12.8686 81.0043L15 80.864L15 83L13 83ZM12.8686 112.792C4.56472 112.245 -2 105.339 -2 96.8981L2 96.8981C2 103.218 6.91608 108.391 13.1314 108.801L12.8686 112.792ZM-2 96.8981C-2 88.457 4.56472 81.5509 12.8686 81.0043L13.1314 84.9957C6.91608 85.4048 2 90.5782 2 96.8981L-2 96.8981ZM15 83L15 110.796L11 110.796L11 83L15 83Z",
    fill: "#8B93A7",
    mask: "url(#path-10-inside-1_18278_92738)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18278_92738",
    x1: 102.261,
    y1: 23,
    x2: 65.0061,
    y2: 102.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBE2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94B1EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18278_92738",
    x1: 112,
    y1: 54,
    x2: 116.117,
    y2: 99.8932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83EDF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65AECD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSayhiCover);
export default __webpack_public_path__ + "static/media/sayhi-cover.051c541927ad09cecf141201559d27ee.svg";
export { ForwardRef as ReactComponent };